export default function PrivacyPolicyPage() {
    return (
        <div className="container -legalPages main">
            <div className="row">
                <div className="col-md-10 offset-md-2">
                    <div className="row d-flex header-container">
                        <h2 className="header">
                            Further Corporation Limited Privacy Policy
                        </h2>
                        <br />
                        <p>
                            Effective 01 September 2021
                            <br /><br /><br />
                        </p>
                        <hr />
                    </div>
                    <br />
                    <div className="row d-flex">
                        <h4>PURPOSE OF THIS PRIVACY NOTICE</h4>
                        <p>
                            Further Corporation Limited is committed to protecting and respecting your privacy. This notice sets out
                            how Further Corporation Limited will use and protect any information that you provide when you use any
                            aspect of our services including, website and mobile applications. As a client of Further Corporation
                            Limited, we hold personal information (known as "personal data"). Personal data refers to
                            information from which you as an individual can be identified.
                        </p>
                        <p>
                            This website is not intended for children and we do not knowingly collect data relating to children.
                        </p>
                        <p>
                            It is important that you read this privacy notice together with any other privacy notice or fair
                            processing notice we may provide on specific occasions when we are collecting or processing personal
                            data about you so that you are fully aware of how and why we are using your data. This privacy notice
                            supplements the other notices and is not intended to override them.
                        </p>
                        <p>
                            You agree that we can collect Your Personal Information so that You can be provided with identity
                            checking services, (which may include Health record verification check), facilitated through the Further
                            Network&trade; Platform. Without this information, Your ID Documents cannot be validated and the Further
                            Network&trade; Platform and any related services cannot be provided.
                        </p>
                        <p>
                            We collect information when You use the Website or the FurtherPass App. For example:
                            <ul>
                                <li>
                                    we collect Personal Information such as Your name and address from You when You use the Further
                                    Network&trade; Platform;
                                </li>
                                <li>
                                    we may collect information from an ID Document which You use to authenticate Your identity or
                                    complete Health record verification check;
                                </li>
                                <li>
                                    we may collect Your email address for validation purposes;
                                </li>
                                <li>
                                    when You use the Further Network&trade; Platform to verify Your identity or complete Health record
                                    verification check for an Organisation, we, or our third party provider may, collect information
                                    about this process, including the details of queries and responses submitted through a check.
                                </li>
                            </ul>
                        </p>
                        <p>
                            If You use the FurtherPass App, the FurtherPass App Provider may also collect information about the
                            Device that You use to access the FurtherPass App, such as physical location, operating system, settings
                            and security protocols. The FurtherPass App Provider may use this information, and disclose it to us and
                            service providers, to assist in providing the Further Network&trade; Platform and enforcing these Terms
                            of Use and the EULA.
                        </p>
                        <p>
                            You acknowledge that information about the ID Documents that You provide may be given to ID Verifiers
                            and other issuing authorities to confirm whether it matches information held by the authority or entity
                            that issued the ID Document. You agree that the ID Verifiers can give us information about whether there
                            is a match, and that we can use that matched information in providing our identity checking services. If
                            we offer checking of an ID Document issued overseas and You provide such an ID Document in connection
                            with the Further Network&trade; Platform, You agree that information may be transferred internationally
                            for the purpose of this identity checking process, and that we may use third party systems and services
                            as we engage with government ID Verifiers.
                        </p>
                        <p>
                            We may hold some information about US and non-US residents as a result of the provision of our services.
                            We may use this information to assist in checking details of information about Your identity and/ or
                            complete a visa entitlement verification check. Details checked in this way may be disclosed to
                            participating Organisations who access the Further Network&trade; Platforms with Your consent to
                            authenticate Your identity and/ or complete a health documents entitlement verification check. By
                            registering a Profile, You agree that we may link some details of this information to Your Profile,
                            which helps us keep Your registered information up-to-date.
                        </p>
                        <p>
                            We will disclose Your information to some other third party ID Verifiers (including Department of
                            Immigration and Border Protection) to assist in the administration of the Further Network&trade;
                            Platform and in order to verify Your details, and may collect some Personal Information from them.
                        </p>
                        <p>
                            Where we check an ID Document, we may retain Your Personal Information and details from the ID Document
                            as well as details of the check we performed and the result of the check for audit and assurance
                            purposes. We do not store images of ID Documents.
                        </p>
                        <p>
                            If You register a Profile:
                            <ul>
                                <li>
                                    we may store some information, including Your name, date of birth, email address and address, and ID
                                    Document numbers, in an encrypted form on your mobile device storage and will only use or share them
                                    with Your express consent in connection with Your future use of the Further Network&trade; Platform;
                                </li>
                                <li>
                                    we may also store other Personal Information, information about the types of ID Document You have
                                    checked with the Further Network&trade; Platform for Your future use of the Further
                                    Network&trade; Platforms;
                                </li>
                                <li>
                                    we may disclose the information we have collected about You in connection with the Further
                                    Network&trade; Platforms (including Personal Information) to the FurtherPass App Provider for the
                                    purposes of the Further Network&trade; Platforms it provides;
                                </li>
                                <li>
                                    the FurtherPass App Provider may collect and disclose to us the information (including Personal
                                    Information) about You in order to facilitate the Further Network&trade; Platform;
                                </li>
                                <li>
                                    some information may be stored on Your Device (for example, Your name and photo are stored so these
                                    can be displayed in the FurtherPass App to personalise Your experience).
                                </li>
                            </ul>
                        </p>
                        <p>
                            Your information will be used to check Your identity or complete a Health record check for an
                            Organisation only with Your specific consent. You may give the consent to us through the Further
                            Network&trade; Platform via the Website or the FurtherPass App, or directly to the Organisation. If You
                            do not use the Further Network&trade; Platform to check Your identity to any Organisation for an
                            extended period, the information stored in Your Profile may be deleted.
                        </p>
                        <p>
                            You hereby authorise us to disclose the information we hold about You and grant access to Your Profile
                            to law enforcement and government authorities and agencies in accordance with their lawful requests.
                        </p>
                        <p>
                            Your Personal Information will be collected and handled securely, and only for the purpose of checking
                            Your identity or facilitating that checking process. Your Personal Information is handled in accordance
                            with the Further Network Privacy Policy which outlines how to access and/or correct Your Personal
                            Information or make a privacy-related complaint. For more information please visit
                            https://furtherpass.com/privacy-policy
                        </p>

                        <h4>DATA CONTROLLER</h4>
                        <p>
                            Company, we, us&nbsp;or our&nbsp;in this&nbsp;privacy&nbsp;notice)
                            and
                        </p>
                        <p>
                            Further Corporation Limited and business partners are jointly the data controllers and jointly
                            responsible, where applicable, for your personal data (collectively referred to
                            as <strong>Company</strong>, <strong>we</strong>, <strong>us</strong> or <strong>our</strong> in this
                            privacy notice) and ensuring your data is processed in compliance with the General Data Protection
                            Regulation (<strong>GDPR</strong>) or such data protection legislation as may be in force from time to
                            time.
                        </p>
                        <p>
                            This privacy notice is issued on behalf of the Company Group so when we mention Company, we, us or our
                            in this privacy notice, we are referring to the relevant company in the Company Group responsible for
                            processing your data. The Company will be the controller for your data when you purchase a product or
                            service with us. The Company is responsible for this website.
                        </p>
                        <p>
                            We have appointed a data privacy manager who is responsible for overseeing questions in relation to this
                            privacy notice. If you have any questions about this privacy notice, including any requests to exercise
                            your legal rights, please contact the data privacy manager using the details set out below.
                        </p>

                        <h4>CONTACT DETAILS</h4>
                        <p>Our full details are:</p>
                        <p>
                            Full name of legal entity: Further Corporation Limited
                        </p>
                        <p>
                            Email address: furtherpass [at] further.network
                        </p>
                        <p>
                            Postal address: Aldgate Tower, 2 Leman Street, London, E1 8QN, United Kingdom
                        </p>

                        <h4>CHANGES TO THE PRIVACY NOTICE AND YOUR DUTY TO INFORM US OF CHANGES</h4>
                        <p>
                            This policy was last updated on the Version Date displayed at the top of the policy.
                        </p>
                        <p>
                            Any changes we make to our privacy policy in the future will be posted on this page and, where
                            appropriate and possible, notified to you by email. Please check back frequently to see any updates or
                            changes to our privacy policy.
                        </p>
                        <p>
                            It is important that the personal data we hold about you is accurate and current. Please keep us
                            informed if your personal data changes during your relationship with us. Where we need to collect
                            personal data by law, or under the terms of a contract we have with you and if you fail to provide that
                            data when requested, we may not be able to perform the contract we have or are trying to enter into with
                            you (for example, to provide you with goods or services). In this case, we may have to cancel a product
                            or service you have with us but we will notify you if this is the case at the time.
                        </p>
                        <p>
                            Please read the following carefully to understand our views and practices regarding your personal data
                            and how we will treat it. By visiting our website and using our products and services you are accepting
                            and consenting to the practices described in this policy.
                        </p>

                        <h4>THIRD-PARTY LINKS</h4>
                        <p>
                            This website may include links to third-party websites, plug-ins and applications. Clicking on those
                            links or enabling those connections may allow third parties to collect or share data about you. We do
                            not control these third-party websites and are not responsible for their privacy statements. When you
                            leave our website, we encourage you to read the privacy notice of every website you visit.
                        </p>

                        <h4>INFORMATION WE COLLECT FROM YOU</h4>
                        <p>
                            Personal data, or personal information, means any information about an individual from which that person
                            can be identified. It does not include data where the identity has been removed (<strong>anonymous
                                data</strong>).
                        </p>
                        <p>
                            We may collect, use, store and transfer different kinds of personal data about you which we have grouped
                            together follows:
                            <ul>
                                <li>
                                    <strong>Identity Data</strong> includes information about your identity such as name, address, date
                                    of birth, username or similar identifier, title, gender.
                                </li>
                                <li>
                                    <strong>Contact Data</strong> includes where you live and how to contact you including: address,
                                    email address and telephone numbers.
                                </li>
                                <li>
                                    <strong>Financial Data</strong> includes information about your financial position, status and
                                    history, and payment account details (can include bank, credit, payment and electronic money
                                    accounts and cryptocurrency wallets).
                                </li>
                                <li>
                                    <strong>Transaction Data</strong> includes details about transactions you make with or through us.
                                </li>
                                <li>
                                    <strong>Health Data</strong> includes details about transactions you make with or through us
                                    including transactions relating to Covid19 test results and/or vaccination data. Health data on the
                                    basis of your consent obtained when you uploaded the data into the Platform and accepted the privacy
                                    policy; or Processing is necessary for reason of public interest in the area of public health.
                                </li>
                                <li>
                                    <strong>Technical Data</strong> includes details about the devices and technology you use including
                                    internet protocol (IP) address, your login data, browser type and version, time zone setting and
                                    location, browser plug-in types and versions, operating system and platform and other technology on
                                    the devices you use to access our website or services.
                                </li>
                                <li>
                                    <strong>Profile Data</strong> includes your username and password, purchases made by you, your
                                    interests, preferences, feedback and survey responses.
                                </li>
                                <li>
                                    <strong>Usage Data</strong> includes information about how you use our website, products and
                                    services.
                                </li>
                                <li>
                                    <strong>Marketing and Communications Data</strong> includes your preferences in receiving marketing
                                    from us and our third parties and your communication preferences.
                                </li>
                                <li>
                                    We also collect, use and share <strong>Aggregated Data</strong> such as statistical or demographic
                                    data for any purpose. Aggregated Data may be derived from your personal data but is not considered
                                    personal data in law as this data does <strong>not</strong> directly or indirectly reveal your
                                    identity. For example, we may aggregate your Usage Data to calculate the percentage of users
                                    accessing a specific website feature. However, if we combine or connect Aggregated Data with your
                                    personal data so that it can directly or indirectly identify you, we treat the combined data as
                                    personal data which will be used in accordance with this privacy notice.
                                </li>
                                <li>
                                    We also may transfer your personal data to our business partners which are laboratories we
                                    collaborate with.
                                </li>
                            </ul>
                        </p>

                        <h4>HOW YOUR PERSONAL DATA IS COLLECTED</h4>
                        <p>
                            We use different methods to collect data about you including through:
                            <ul>
                                <li><strong>Information you give us:</strong>
                                    <ul>
                                        <li>when you apply for, or use, our products or services;</li>
                                        <li>when you subscribe;</li>
                                        <li>create an account on our website or mobile app;</li>
                                        <li>when you communicate with us whether by phone, post, email, online or by other means;</li>
                                        <li>when you use our websites or device applications;</li>
                                        <li>in emails, letters and other correspondence;</li>
                                        <li>give us feedback; and</li>
                                        <li>when you request marketing to be sent to you by us or selected third parties;</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Automated technologies or interactions.</strong> As you interact with our website, we may
                                    automatically collect Technical Data about your equipment, browsing actions and patterns. We collect
                                    this personal data by using cookies, server logs and other similar technologies. Please see the
                                    section on Cookies below.
                                </li>
                                <li>
                                    <strong>Your use of our services</strong>. The data we collect when you use our services (such as
                                    making transactions, viewing your account details or using any part of our website) includes:
                                    <ul>
                                        <li>Transaction Data;</li>
                                        <li>Profile Data;</li>
                                        <li>Usage Data; and</li>
                                        <li>Technical Data</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Third parties or publicly available sources</strong>. We may receive personal data about you
                                    from various third parties and public sources as set out below:
                                    <ul>
                                        <li>Companies that introduce you to us;</li>
                                        <li>Government and law enforcement agencies; and</li>
                                        <li>Agents working on our behalf including fraud prevention agencies, analytics providers,
                                            advertisers.
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </p>

                        <h4>HOW WE USE YOUR DATA</h4>
                        <p>
                            We will only use your personal data when the law allows us to. Most commonly, we will use your personal
                            data in the following circumstances:
                            <ul>
                                <li>Where you consent to it;</li>
                                <li>
                                    Where we need to perform the contract we are about to enter into or have entered into with you;
                                </li>
                                <li>
                                    Where it is necessary for our legitimate interests (or those of a third party) and your interests
                                    and fundamental rights do not override those interests; and
                                </li>
                                <li>Where we need to comply with a legal or regulatory obligation.</li>
                            </ul>
                        </p>

                        <h4>PURPOSES FOR WHICH WE WILL USE YOUR PERSONAL DATA</h4>
                        <p>
                            We have set out below, in a table format, a description of all the ways we plan to use your personal
                            data, and which of the legal bases we rely on to do so. We have also identified what our legitimate
                            interests are where appropriate.
                        </p>
                        <p>
                            Note that we may process your personal data for more than one lawful ground depending on the specific
                            purpose for which we are using your data. Please contact us if you need details about the specific legal
                            ground we are relying on to process your personal data where more than one ground has been set out in
                            the table below.
                        </p>

                        <table>
                            <tbody>
                                <tr>
                                    <td><strong>Purpose/Activity</strong></td>
                                    <td><strong>Type of data</strong></td>
                                    <td><strong>Lawful basis for processing including basis of legitimate interest</strong></td>
                                </tr>
                                <tr>
                                    <td>
                                        To register you as a new customer / to verify your identity, to open an account, provide a health
                                        pass services to you and manage our relationship with you (e.g. inform you of changes and
                                        correspond with you)
                                    </td>
                                    <td>
                                        <ol className="typea">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Financial</li>
                                            <li>Transaction</li>
                                            <li>Marketing and Communications</li>
                                        </ol>
                                    </td>
                                    <td>
                                        <ol>
                                            <li>Performance of a contract with you</li>
                                            <li>Necessary to comply with a legal obligation</li>
                                            <li>Necessary for our legitimate interests (e.g. risk management and fraud prevention)</li>
                                            <li>Consent</li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr className="c46">
                                    <td>To enable you to use your account to make and receive payment transactions.</td>
                                    <td>
                                        <ol className="typea">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Financial</li>
                                            <li>Transaction</li>
                                        </ol>
                                    </td>
                                    <td>
                                        <ol>
                                            <li>Performance of a contract with you</li>
                                            <li>Necessary to comply with a legal obligation</li>
                                            <li>Necessary for our legitimate interests (e.g. risk management and fraud prevention).</li>
                                            <li>Consent</li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr className="c55">
                                    <td>
                                        To administer and protect our business, your account and our website, to improve our website and
                                        products/services (including troubleshooting, data analysis, testing, system maintenance, support,
                                        security, reporting, complying with our regulatory obligations and hosting of data)
                                    </td>
                                    <td>
                                        <ol className="typea">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Financial</li>
                                            <li>Transaction</li>
                                            <li>Usage</li>
                                        </ol>
                                    </td>
                                    <td>
                                        <ol>
                                            <li>
                                                Necessary for our legitimate interests (for running our business, provision of administration
                                                and IT services, network security, to prevent fraud and in the context of a business
                                                reorganisation or group restructuring exercise)
                                            </li>
                                            <li>
                                                Necessary to comply with a legal obligation.
                                            </li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr className="c56">
                                    <td>
                                        To manage our relationship with you which will include notifying you about changes to our terms or
                                        privacy policy.
                                    </td>
                                    <td>
                                        <ol className="typea">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Profile</li>
                                            <li>Marketing and Communications</li>
                                        </ol>
                                    </td>
                                    <td>
                                        <ol>
                                            <li>Performance of a contract with you</li>
                                            <li>Necessary to comply with a legal obligation</li>
                                            <li>Necessary for our legitimate interests (e.g. risk management and fraud prevention).</li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr className="c40">
                                    <td>
                                        To give you, or allow selected third parties to give you, services about your travel we think you
                                        may be interested in.
                                    </td>
                                    <td>
                                        <ol className="typea">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Profile</li>
                                            <li>Usage</li>
                                            <li>Health Data</li>
                                            <li>Marketing and Communications</li>
                                            <li>Technical</li>
                                        </ol>
                                    </td>
                                    <td>
                                        <ol>
                                            <li>Consent</li>
                                            <li>
                                                Necessary for our legitimate interests (to study how customers use our products/services, to
                                                develop them, to grow our business, to inform our marketing strategy to develop new
                                                products/services and grow our business)
                                            </li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        To enable you to partake in a prize draw, competition or complete a survey.
                                    </td>
                                    <td>
                                        <ol className="typea">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Profile</li>
                                            <li>Usage</li>
                                            <li>Marketing and Communications</li>
                                        </ol>
                                    </td>
                                    <td>
                                        <ol>
                                            <li>Performance of a contract with you.</li>
                                            <li>
                                                Necessary for our legitimate interests (to study how customers use our products/services, to
                                                develop them and grow our business).
                                            </li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        To deliver relevant website content and advertisements to you and measure or understand the
                                        effectiveness of the advertising we serve to you.
                                    </td>
                                    <td>
                                        <ol className="typea">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Profile</li>
                                            <li>Usage</li>
                                            <li>Marketing and Communications</li>
                                            <li>Technical</li>
                                        </ol>
                                    </td>
                                    <td>
                                        Necessary for our legitimate interests (to study how customers use our products/services, to
                                        develop them, to grow our business and to inform our marketing strategy)
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        To use data analytics to improve our website, products/services, marketing, customer relationships
                                        and experiences.
                                    </td>
                                    <td>
                                        <ol className="typea">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Technical</li>
                                            <li>Usage</li>
                                            <li>Profile</li>
                                        </ol>
                                    </td>
                                    <td>
                                        Necessary for our legitimate interests (to develop our products/services and grow our business)
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <p>&nbsp;</p>
                        <h4>MARKETING</h4>
                        <p>
                            We strive to provide you with choices regarding certain personal data uses, particularly around
                            marketing and advertising.
                        </p>

                        <h4>PROMOTIONAL OFFERS FROM US</h4>
                        <p>
                            We may use your Identity, Contact, Technical, Usage and Profile Data to form a view on what we think you
                            may want or need, or what may be of interest to you. This is how we decide which products, services and
                            offers may be relevant for you (we call this marketing).
                        </p>
                        <p>
                            You will receive marketing communications from us if you have requested information from us or purchased
                            services from us and, in each case, you have not opted out of receiving that marketing.
                        </p>

                        <h4>THIRD-PARTY MARKETING</h4>
                        <p>
                            We will get your express opt-in consent before we share your personal data with any company outside our
                            group of companies for marketing purposes.
                        </p>

                        <h4>OPTING OUT</h4>
                        <p>
                            You can ask us or third parties to stop sending you marketing messages at any time by emailing us at
                            furtherpass@further.network
                        </p>

                        <h4>CHANGE OF PURPOSE</h4>
                        <p>
                            We will only use your personal data for the purposes for which we collected it, unless we reasonably
                            consider that we need to use it for another reason and that reason is compatible with the original
                            purpose. If you wish to get an explanation as to how the processing for the new purpose is compatible
                            with the original purpose, please contact us.
                        </p>
                        <p>
                            If we need to use your personal data for an unrelated purpose, we will notify you and we will explain
                            the legal basis which allows us to do so.
                        </p>
                        <p>
                            Please note that we may process your personal data without your knowledge or consent, in compliance with
                            the above rules, where this is required or permitted by law.
                        </p>

                        <h4>WHO WE MAY DISCLOSE YOUR INFORMATION TO</h4>
                        <p>
                            You agree that we may disclose your personal information to:
                            <ul>
                                <li>
                                    Any member of our group of companies, which means our subsidiaries, our ultimate holding company
                                    and its subsidiaries as reasonably necessary for the purposes, and on the legal bases, detailed in
                                    this policy;
                                </li>
                                <li>
                                    Our agents, advisors and business partners who we use to help manage your accounts and services,
                                    improve services and resolve issues such as legal disputes;
                                </li>
                                <li>HM Revenue &amp; Customs, regulators and other authorities;</li>
                                <li>
                                    Fraud prevention and credit reference agencies for the purpose of verifying your identity and
                                    ensuring the security of your account;
                                </li>
                                <li>Any party linked with you or your business&rsquo;s products or services;</li>
                                <li>Organisations that introduce you to us;</li>
                                <li>Organisations we introduce you to for marketing purposes;</li>
                                <li>
                                    Analytics and search engine providers that assist us in the improvement and optimisation of our
                                    website;
                                </li>
                                <li>Any insurance company for the purposes of insuring risk; and</li>
                                <li>
                                    Other entities where we are obliged to by law or to law enforcement agencies for the purposes of
                                    registration of fraud or suspected fraud or where we have your consent.
                                </li>
                            </ul>
                        </p>

                        <p>
                            You agree that we can and will disclose your personal information to third parties:
                            <ul>
                                <li>
                                    In the event that we sell or buy any business or assets, in which case we will disclose your
                                    personal data to the prospective seller or buyer of such business or assets;
                                </li>
                                <li>
                                    If substantially all of our assets are acquired by a third party, in which case personal data held
                                    by it about its customers will be one of the transferred assets;
                                </li>
                                <li>
                                    If we are under a duty to disclose or share your personal data in order to comply with any legal
                                    obligation, or in order to enforce or apply our terms of use and other agreements; or to protect the
                                    rights, property, or safety of us, our customers, or others. This includes exchanging information
                                    with other companies and organisations for the purposes of fraud protection and credit risk
                                    reduction.
                                </li>
                            </ul>
                        </p>

                        <p>
                            In addition to the disclosures detailed in this section, we may also disclose your personal information
                            where it is necessary to do so: for compliance with a legal obligation; in order to protect the vital
                            interests of you or another natural person; and for the establishment, exercise or defence of legal
                            claims.
                        </p>
                        <p>
                            We require all third parties to respect the security of your personal data and to treat it in accordance
                            with the law. We do not allow our third-party service providers to use your personal data for their own
                            purposes and only permit them to process your personal data for specified purposes and in accordance
                            with our instructions.
                        </p>

                        <h4>HOW WE USE YOUR INFORMATION TO MAKE AUTOMATED DECISIONS</h4>
                        <p>
                            We may use systems to make automated decisions based on information we hold about you. This helps us to
                            make sure our decisions are quick, fair, efficient and correct, based on what we know. These automated
                            decisions can affect the products, services or features we may offer you now or in the future. The
                            following are some of the ways we may use systems to make automated decisions:
                        </p>

                        <p><em>Tailoring products and services</em></p>
                        <p>
                            We may use your data along with that of other customers in order to study and learn about our
                            customers&rsquo; needs, and to make decisions based on what we learn. This helps us to design products
                            and services for different customer groups, and to manage our relationships with them.
                        </p>

                        <p><em>Fraud detection</em></p>
                        <p>
                            We use your personal information to help determine if your account is being used fraudulently or for
                            money-laundering. If there is a risk of fraud, or money laundering, we may suspend or terminate your
                            account and refuse access to your account.
                        </p>

                        <p><em>Opening accounts</em></p>
                        <p>
                            We may use automated checks to help determine if you satisfy our criteria for an account, including
                            fraud, money laundering and eligibility checks.
                        </p>

                        <p>
                            <strong>Your rights with respect to automated decisions:</strong>
                            <ul>
                                <li>
                                    You can ask that we do not make our decision based on the automated decision alone.
                                </li>
                                <li>
                                    You can object to an automated decision, and ask that a person reviews it.
                                </li>
                                <li>
                                    If you want to know more about these rights, or to exercise them, please contact us.
                                </li>
                            </ul>
                        </p>

                        <h4>WHERE WE STORE AND TRANSFER YOUR PERSONAL DATA</h4>
                        <p>
                            All information you provide to us will be transferred and stored in a jurisdiction located in the
                            European Economic Area (<strong>EEA</strong>). However, we may transfer some or all of your data to
                            countries outside of the EEA which may not offer the same level of protection as the GDPR with respect
                            to the processing of your personal data. Where your data is transferred to such countries either a
                            derogation allowed under Article 49 of the GDPR will apply or your data will be protected by appropriate
                            safeguards, namely the use of standard data protection clauses adopted or approved by the European
                            Commission (<strong>EC</strong>) can be found on the EC&rsquo;s website: <a target="_blank"
                                rel="noopener noreferrer nofollow"
                                href="https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/model-contracts-transfer-personal-data-third-countries_en">here</a>
                        </p>
                        <p>
                            Where data is to be transferred to a group company in a country outside of the EEA which may not offer
                            the same level of protection as the GDPR with respect to the processing of your personal data, we will
                            ensure that the group company agrees to binding corporate rules in accordance with Article 47 of the
                            GDPR. Further information can be found on the EC&rsquo;s website: <a target="_blank"
                                rel="noopener noreferrer nofollow"
                                href="https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/binding-corporate-rules_en">here</a>
                        </p>
                        <p>
                            Where we transfer data to organisations based in the US, we may transfer data to them if they are part
                            of the Privacy Shield which requires them to provide similar protection to personal data shared between
                            the EEA and the US. For further details, see EC&rsquo;s website page: <a target="_blank"
                                rel="noopener noreferrer nofollow"
                                href="https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/eu-us-data-transfers_en#eu-us-privacy-shield">here</a>
                        </p>

                        <h4>DATA SECURITY</h4>
                        <p>
                            We have put in place appropriate security measures to prevent your personal data from being accidentally
                            lost, used or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to
                            your personal data to those employees, agents, contractors and other third parties who have a business
                            need to know. They will only process your personal data on our instructions and they are subject to a
                            duty of confidentiality.
                        </p>
                        <p>
                            We have put in place procedures to deal with any suspected personal data breach and will notify you and
                            any applicable regulator of a breach where we are legally required to do so.
                        </p>

                        <h4>KEEPING AND DELETING YOUR DATA</h4>
                        <p>
                            We will only retain your personal data for as long as necessary to fulfil the purposes we collected it
                            for, including for the purposes of satisfying any legal, accounting, or reporting requirements.
                        </p>
                        <p>
                            To determine the appropriate retention period for personal data, we consider the amount, nature, and
                            sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your
                            personal data, the purposes for which we process your personal data and whether we can achieve those
                            purposes through other means, and the applicable legal requirements.
                        </p>
                        <p>
                            We keep certain data for minimum periods, namely:
                            <ul>
                                <li>
                                    we retain Transaction Data for a minimum of six years after the date of the transaction;
                                </li>
                                <li>
                                    we retain certain Account Information for a minimum of six years after your agreement with us has
                                    ended.
                                </li>
                            </ul>
                        </p>
                        <p>
                            The majority of personal data we hold will be deleted 10 years after the termination of any agreement
                            you have with us unless it is needed for other necessary or legitimate purposes.
                        </p>
                        <p>
                            In some circumstances you can ask us to delete your data: see request erasure below for further
                            information.
                        </p>
                        <p>
                            In some circumstances we may anonymise your personal data (so that it can no longer be associated with
                            you) for research or statistical purposes in which case we may use this information indefinitely without
                            further notice to you.
                        </p>

                        <h4>YOUR RIGHTS</h4>
                        <p>
                            Under the GDPR you have the right to:
                            <ul>
                                <li>
                                    <strong>Request access to your personal data</strong> (commonly known as a &quot;data subject access
                                    request&quot;). This enables you to receive a copy of the personal data we hold about you and to
                                    check that we are lawfully processing it.
                                </li>
                                <li>
                                    <strong>Request correction of the personal data that we hold about you.</strong> This enables you to
                                    have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the
                                    accuracy of the new data you provide to us.
                                </li>
                                <li>
                                    <strong>Request erasure of your personal data.</strong> This enables you to ask us to delete or
                                    remove personal data where there is no good reason for us continuing to process it. You also have
                                    the right to ask us to delete or remove your personal data where you have successfully exercised
                                    your right to object to processing (see below), where we may have processed your information
                                    unlawfully or where we are required to erase your personal data to comply with local law. Note,
                                    however, that we may not always be able to comply with your request of erasure for specific legal
                                    reasons which will be notified to you, if applicable, at the time of your request.
                                </li>
                                <li>
                                    <strong>Object to processing of your personal data</strong> where we are relying on a legitimate
                                    interest (or those of a third party) and there is something about your particular situation which
                                    makes you want to object to processing on this ground as you feel it impacts on your fundamental
                                    rights and freedoms. You also have the right to object where we are processing your personal data
                                    for direct marketing purposes. In some cases, we may demonstrate that we have compelling legitimate
                                    grounds to process your information which override your rights and freedoms.
                                </li>
                                <li>
                                    <strong>Request the transfer of your personal data to you or to a third party</strong>. We will
                                    provide to you, or a third party you have chosen, your personal data in a structured, commonly used,
                                    machine-readable format. Note that this right only applies to automated information which you
                                    initially provided consent for us to use or where we used the information to perform a contract with
                                    you.
                                </li>
                                <li>
                                    <strong>Withdraw consent</strong> at any time where we are relying on consent to process your
                                    personal data. However, this will not affect the lawfulness of any processing carried out before you
                                    withdraw your consent. If you withdraw your consent, we may not be able to provide certain products
                                    or services to you. We will advise you if this is the case at the time you withdraw your consent.
                                </li>
                            </ul>
                        </p>
                        <p>
                            If you wish to exercise any of these rights you will need to contact us using the contact details above.
                            In the case of exercising your right to access, you will also need to provide appropriate evidence of
                            your identity.
                        </p>

                        <h4>GOVERNING LAW</h4>
                        <p>
                            National law of your nationality applies to any disputes arising out of, or in connection with your
                            personal data if you are an EU citizen and English law applies to any disputes arising out of, or in
                            connection with your personal data if you are not an EU citizen.
                        </p>

                        <h4>NO FEE USUALLY REQUIRED</h4>
                        <p>
                            You will not have to pay a fee to access your personal data (or to exercise any of the other rights).
                            However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive.
                            Alternatively, we may also refuse to comply with your request in these circumstances.
                        </p>

                        <h4>WHAT WE MAY NEED FROM YOU</h4>
                        <p>
                            We may need to request specific information from you to help us confirm your identity and ensure your
                            right to access your personal data (or to exercise any of your other rights). This is a security measure
                            to ensure that personal data is not disclosed to any person who has no right to receive it. We may also
                            contact you to ask you for further information in relation to your request to speed up our response.
                        </p>

                        <h4>CONTACT</h4>
                        <p>
                            Questions, comments and requests regarding this privacy policy are welcomed and should be addressed to
                            the contact details at the start of this policy.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    )
}